import { shareIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Share = createIcon({
  displayName: 'Share',
  paths: [
    'M597.333 298.667c0-70.699 57.301-128 128-128s128 57.301 128 128c0 70.699-57.301 128-128 128-34.517 0-65.839-13.658-88.862-35.866l-210.775 105.362c0.64 5.188 0.97 10.475 0.97 15.838 0 5.35-0.328 10.624-0.966 15.799l210.779 105.391c23.023-22.204 54.34-35.857 88.853-35.857 70.699 0 128 57.301 128 128s-57.301 128-128 128c-70.699 0-128-57.301-128-128 0-5.355 0.329-10.633 0.969-15.812l-210.768-105.395c-23.021 22.212-54.347 35.874-88.867 35.874-70.699 0-128-57.301-128-128s57.301-128 128-128c34.511 0 65.829 13.654 88.849 35.855l210.782-105.383c-0.636-5.178-0.964-10.453-0.964-15.805z'
  ],
  canvasPaths: canvasIconPaths(shareIcon)
})
